import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { ToWords } from 'to-words';

@Component({
  selector: 'app-bookstorereceipt',
  templateUrl: './bookstorereceipt.component.html',
  styleUrls: ['./bookstorereceipt.component.scss'],
})
export class BookstorereceiptComponent implements OnInit {

  bookdata: any;
  receiptno: any;
  value = 0;
  data: any;
  bookpymtrcptdata: any[] = [];
  booklist: any[] = [];
  totalinWords: string = '';
  payloadArray: any;
  recptNoValue: number;
  

  constructor(
    public service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookstorereceiptComponent>,
    @Inject(MAT_DIALOG_DATA) public dataa: any
  ) {}

  ngOnInit(): void {
    debugger;
    this.data = this.dataa?.data || {};
    this.bookpymtrcptdata = this.dataa?.bookpymtrcptdata || [];
    this.booklist = this.dataa?.bookpricedata || [];
    this.bookdata = this.dataa?.book || {};
    this.value = this.dataa?.val || 0;
    this.receiptno = this.data?.recptno || '';

    const toWords = new ToWords();
    this.totalinWords = toWords.convert(this.value, { currency: true });
  }

  /* 🔥 KEY FUNCTION */
  getDisplayNumber(book: any): string {
    if (book?.invoice_no && book.invoice_no.startsWith('V')) {
      return book.invoice_no;
    }

    if (book?.order_no && book.order_no.startsWith('B')) {
      return book.order_no;
    }

    return '';
  }


  print() {
    window.print();
  }

save() {
  debugger

    this.payloadArray = this.booklist.map((bookArray) => {
      // Ensure bookArray is an array before using reduce
      const totalReceivedAmount = (Array.isArray(bookArray))
      ? bookArray.reduce((sum, book) => sum + (Number(book.rcvd_amt) || 0), 0)
      : 0;
    
    console.log("Total Received Amount:", totalReceivedAmount);
  
      // Extract order_no from the first book in the array
      const orderNo = Array.isArray(bookArray) && bookArray.length > 0 
          ? bookArray[0].order_no 
          : '';
           const matchedRecord =
    this.bookpymtrcptdata.find((r) => r['order_no'] === orderNo) ||
    this.bookpymtrcptdata[0] || {};
  
      return {
          date: this.data?.date || '',
          crdtvno: this.data?.crdtvno || '',
          entrydate: this.dataa['book']["entry_date"] || '',
          recptdate: this.data?.recptdate || '',
          repname: this.bookpymtrcptdata[0]["rep_name"] || '',
          ofcrepname: this.bookpymtrcptdata[0]["office_rep_name"] || '',
          recptno: this.data?.recptno || '',
          crdtvamt: this.data?.crdtvamt || 0,
          mob_no: matchedRecord['mobile'] || '',
          district: matchedRecord['district'] || '',
          seamt: totalReceivedAmount, // Sum of rcvd_amt for each inner array
          booksellername: this.bookpymtrcptdata[0]["receiver_name"] || '',
          bname: this.data?.bname || '',
          balamt: this.data?.balamt || 0,
          billno: bookArray || [], // Ensure billno is always an array
          value:  this.recptNoValue || 0,
          order_no: orderNo // Assign extracted order_no
          // seamt:totalReceivedAmount
      };
      
  });

  const uniqueRecipients = new Map<string, any>();
this.payloadArray.forEach((entry) => {
  if (entry.mob_no && !uniqueRecipients.has(entry.mob_no)) {
    uniqueRecipients.set(entry.mob_no, entry);
  }
});

  uniqueRecipients.forEach((entry) => {
  this.sendingBookPymtWhatsAppMessage(entry);
});
  
  
  console.log("Payload",this.payloadArray);
  
debugger
    this.service.insertBookPymtRcpt(this.payloadArray).subscribe((output) => {
      console.log('bookpymtrcpt id', output);
      for (
        let index = 0;
        index < Object.keys(this.bookpymtrcptdata).length;
        index++
      ) {
        this.service
          .insertBookPymtRcptandInvoicedata(
            output['id'],
            this.bookpymtrcptdata[index]['id']
          )
          .subscribe((data) => {});
      }

      

      //commemt-start

      // this.service
      //   .updatecreditvoucher(
      //     this.bookdata['id'],
      //     this.data['crdtvno'],
      //     this.data['balamt']
      //   )
      //   .subscribe((data) => {
      //     // console.log('updated data', data);
      //   });

      // for (
      //   let index = 0;
      //   index < Object.keys(this.bookpymtrcptdata).length;
      //   index++
      // ) {
      //   if (this.bookpymtrcptdata[index]['invoice_no'].includes('BDO')) {
      //     this.service
      //       .updatebookinvoice(
      //         this.bookpymtrcptdata[index]['id'],
      //         this.bookpymtrcptdata[index]['invoice_no'],
      //         this.bookpymtrcptdata[index]['remaining_amt'],
      //         'bookdata'
      //       )
      //       .subscribe((data) => {
      //         // console.log('update book receipt', data);
      //       });
      //   } else {
      //     this.service
      //       .updatebookinvoice(
      //         this.bookpymtrcptdata[index]['id'],
      //         this.bookpymtrcptdata[index]['invoice_no'],
      //         this.bookpymtrcptdata[index]['remaining_amt'],
      //         'bookinvoice'
      //       )
      //       .subscribe((data) => {
      //         // console.log('update book receipt', data);
      //       });
      //   }
      //   this.service
      //     .insertBookPymtRcptandInvoicedata(
      //       output['id'],
      //       this.bookpymtrcptdata[index]['id']
      //     )
      //     .subscribe((data) => {});
      // }

      // for (
      //   let index = 0;
      //   index < Object.keys(this.bookpricedata).length;
      //   index++
      // ) {
      //   for (
      //     let index1 = 0;
      //     index1 < Object.keys(this.bookpricedata[index]).length;
      //     index1++
      //   ) {
      //     if (this.bookpricedata[index][index1]['invoice_no'].includes('BDO')) {
      //       this.service
      //         .updateRcptWiseBooks1(
      //           this.bookpricedata[index][index1]['bookid'],
      //           this.bookpricedata[index][index1]['rcvd_amt'],
      //           this.bookpricedata[index][index1]['remaining_amt']
      //         )
      //         .subscribe((data) => {
      //           console.log(data);
      //           // alert('Books price added successfully...');
      //           // this.dialogRef.close();
      //         });
      //     } else {
      //       this.service
      //         .updateRcptWiseBooks(
      //           this.bookpricedata[index][index1]['id'],
      //           this.bookpricedata[index][index1]['bookid'],
      //           this.bookpricedata[index][index1]['book_name'],
      //           this.bookpricedata[index][index1]['rcvd_amt'],
      //           this.bookpricedata[index][index1]['remaining_amt']
      //         )
      //         .subscribe((data) => {
      //           console.log(data);
      //           // this.dialogRef.close();
      //         });
      //     }
      //   }
      // }

      //comment-end
      
      setTimeout(() => {
        alert('Book payment receipt generated successfully...');
       location.reload();
        this.dialogRef.close();
      }, 1200);
    });
  }
 
//   sendingBookPymtWhatsAppMessage(entry: any) {
//   let sellerLabel = "बुक सेलर -";
//   let name = entry.booksellername;
//   let date = this.formatDateToDDMMYYYY(entry.recptdate);
//   let amount = entry.seamt;
//   let mobile = entry.mob_no.toString();
//   let campaignName = "jamapavati"; // ✅ updated

//   let payload = {
//     campaignName,
//     mobile,
//     templateParams: [sellerLabel, name, date, amount],
//   };

//   this.service.sendWhatsAppMSGBook(payload).subscribe((_a) => {
//     // console.log('book payment msg sent successfully....');
//   });
// }

formatDateToDDMMYYYY(dateInput: string | Date): string {
  if (!dateInput) return '';
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '';

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}

// sendingBookPymtWhatsAppMessage(entry: any) {
//   debugger
//   let sellerLabel = "बुक सेलर -";
//   let name = entry.booksellername;
//   let date = this.formatDateToDDMMYYYY(entry.recptdate);
//   let amount = entry.seamt;

//   // ✅ Ensure 10-digit number, then prefix with country code
//    let mobile = entry.mob_no.toString().trim().replace(/\D/g, '');

//   let campaignName = "jamapavati";

//   let payload = {
//     campaignName,
//     mobile,
//     templateParams: [sellerLabel, name, date, amount],
//   };

//   this.service.sendWhatsAppMSGBook(payload).subscribe(
//     (res) => {
//       console.log('WhatsApp sent to', mobile, res);
//     },
//     (err) => {
//       console.error('WhatsApp send failed for', mobile, err);
//     }
//   );
// }

// sendingBookPymtWhatsAppMessage(entry: any) {
//   // let sellerLabel = "बुक सेलर -";
//   let name = entry.booksellername;
//   let district = entry.district;
//   let date = this.formatDateToDDMMYYYY(entry.recptdate);
//   let amount = entry.seamt;

//   let mobile = entry.mob_no.toString().trim().replace(/\D/g, '');
//   let campaignName = "jamapavati";

//   let payload = {
//     campaignName,
//     mobile,
//     templateParams: [
//       // String(sellerLabel),
//       String(name),
//       String(district),
//       String(date),
//       String(amount),   // ✅ was a number, now a string
//     ],
//   };

//   this.service.sendWhatsAppMSGBook(payload).subscribe(
//     (res) => {
//       console.log('WhatsApp sent to', mobile, res);
//     },
//     (err) => {
//       console.error('WhatsApp send failed for', mobile, err.error);
//     }
//   );
// }


sendingBookPymtWhatsAppMessage(entry: any) {
  let name = entry.booksellername;
  let district = entry.district;
  let date = this.formatDateToDDMMYYYY(entry.recptdate);
  let amount = entry.seamt;

  let mobile = entry.mob_no.toString().trim().replace(/\D/g, '');
  let campaignName = "jamapavati";

  let payload = {
    campaignName,
    mobile,
    templateParams: [
      String(name),
      String(district),
      String(date),
      String(amount),
    ],
  };

  this.service.sendWhatsAppMSGBook(payload).subscribe(
    (res) => {
      console.log('WhatsApp sent to', mobile, res);
    },
    (err) => {
      console.error('WhatsApp send failed for', mobile, err.error);
    }
  );
}
}